import { createActionGroup, emptyProps, props, Action } from '@ngrx/store';

import { CreateNewJobMutationVariables } from '../../generated/graphql.generated';
import { ActionSource } from '../state/action-sources';

import { NewOpportunityStep } from './new-opportunity.state';

export const NewOpportunityActions = createActionGroup({
    source: ActionSource.NEW_OPPORTUNITY,
    events: {
        'Step Clicked': props<{ currentStep: NewOpportunityStep; nextStep: NewOpportunityStep }>(),
        'Next Step Button Clicked': props<{ currentStep: NewOpportunityStep }>(),
        'Previous Step Button Clicked': props<{ currentStep: NewOpportunityStep }>(),
        'Download Summary Button Clicked': emptyProps(),
        'Download Summary Error': props<{ error: Error }>(),
        'Create Job With Missing Location Data Confirmed': emptyProps(),
        'Validate Step Change Success': props<{ step: NewOpportunityStep }>(),
        'Build Create Job Variables Success': props<{
            vars: CreateNewJobMutationVariables;
            promptedBy: Action;
        }>(),
        'Build Create Job Variables Error': props<{ error: Error }>(),
        'Create Job Success': props<{ jobId: string; zoneId: string; promptedBy: Action }>(),
        'Create Job Error': props<{ error: Error }>(),
        'Unsaved Changes Cleared': emptyProps(),
        'Go To Job Button Clicked': emptyProps(),
        'Navigate To Job Page Success': props<{ generateEstimatePreview: boolean; }>(),
        'Change Step And Save Changes Success': props<{ promptedBy: Action }>(),
        'Default Customer Type Loaded': emptyProps(),
        'Default Summary Index Loaded': props<{ summaryIndex: number }>(),
        'Discard Changes Before Navigating To Job Page Confirmed': emptyProps(),
        'Start Location Wizard Completed': emptyProps(),
        'Locations Completed': emptyProps(),
    },
});
